var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgIconSatellite1 = /*#__PURE__*/React.forwardRef((_ref, ref) => {
  let {
    className,
    height = 16,
    titleId,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16",
    className: className,
    height: height,
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m13.025 2.975-.994.994M4.839 14.98a3.306 3.306 0 0 1-3.813-3.856m8.606-2.1 1.326 1.325M6.975 6.369 5.65 5.044m-2.025 7.8a.475.475 0 0 1-.469-.469M3 9.67A2.356 2.356 0 0 1 6.331 13zm9.031-3.05a1.875 1.875 0 0 0-.237-2.856 1.96 1.96 0 0 0-2.5.275L6 7.375a.95.95 0 0 0 0 1.331l1.325 1.325a.95.95 0 0 0 1.331 0zm-1.56 4.212.976-.976s.663-.663 1.326 0l1.989 1.989s.662.662 0 1.325l-.977.977s-.663.663-1.325 0l-1.99-1.988s-.662-.664 0-1.327M1.85 2.22l.977-.976s.662-.664 1.326 0L6.14 3.23s.663.663 0 1.325l-.977.978s-.662.663-1.325 0L1.85 3.545s-.663-.664 0-1.326"
  })));
});
export const Icon = /*#__PURE__*/React.forwardRef((_ref2, ref) => {
  let {
    className: propClassName = "",
    fill = "none",
    stroke = "currentColor",
    weight = "normal",
    height = 16,
    titleId,
    title,
    ...props
  } = _ref2;
  const className = "vector-effect-non-scaling-stroke " + propClassName;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16",
    className: className,
    height: height,
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    fill: fill,
    stroke: stroke,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m13.025 2.975-.994.994M4.839 14.98a3.306 3.306 0 0 1-3.813-3.856m8.606-2.1 1.326 1.325M6.975 6.369 5.65 5.044m-2.025 7.8a.475.475 0 0 1-.469-.469M3 9.67A2.356 2.356 0 0 1 6.331 13zm9.031-3.05a1.875 1.875 0 0 0-.237-2.856 1.96 1.96 0 0 0-2.5.275L6 7.375a.95.95 0 0 0 0 1.331l1.325 1.325a.95.95 0 0 0 1.331 0zm-1.56 4.212.976-.976s.663-.663 1.326 0l1.989 1.989s.662.662 0 1.325l-.977.977s-.663.663-1.325 0l-1.99-1.988s-.662-.664 0-1.327M1.85 2.22l.977-.976s.662-.664 1.326 0L6.14 3.23s.663.663 0 1.325l-.977.978s-.662.663-1.325 0L1.85 3.545s-.663-.664 0-1.326"
  }));
});
export default SvgIconSatellite1;
export const raw = __webpack_public_path__ + "static/media/IconSatellite1.e2e992e9d056e451a67254242498ab41.svg";